import React from 'react';
import PropTypes from 'prop-types';
import css from './FilterBadge.module.css';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';

const FilterBadge = ({ label, onRemove, ariaLabel }) => {
  return (
    <div className={css.filterBadge}>
      <span className={css.filterBadgeLabel}>{label}</span>
      <button
        type="button"
        className={css.filterBadgeRemove}
        onClick={onRemove}
        aria-label={ariaLabel || `Remove ${label}`}
      >
        <CloseIcon width={24} height={24} aria-hidden="true" />
      </button>
    </div>
  );
};

FilterBadge.propTypes = {
  label: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

export default FilterBadge;
